import React from 'react';
import { func, arrayOf, string } from 'prop-types';
import { Box, Divider, Typography } from '@mui/material';

import { EngineOptions } from './styles';
import { Checkbox } from '../../../../../../../../../../components';
import { Form } from '../../../../../../../../../../components/FiltersForm/styles';

import { engineTypeOptions } from '../EngineFilter/utils';

const EngineFilterForm = ({
  selectedBrandManagementFilters,
  updateCustomizations,
}) => {
  const onChange = (event) => {
    const { name, checked } = event.target;

    if (name === 'all') {
      if (checked) {
        updateCustomizations({ brandManagementFilters: engineTypeOptions.map(({ type }) => type) });
      } else {
        updateCustomizations({ brandManagementFilters: [] });
      }
      return;
    }

    const clonedSelectedBrandManagementFilters = [...selectedBrandManagementFilters];

    if (checked) {
      if (!clonedSelectedBrandManagementFilters.includes(name)) {
        clonedSelectedBrandManagementFilters.push(name);
      }
    } else {
      const index = clonedSelectedBrandManagementFilters.indexOf(name);
      if (index !== -1) {
        clonedSelectedBrandManagementFilters.splice(index, 1);
      }
    }

    updateCustomizations({ brandManagementFilters: clonedSelectedBrandManagementFilters });
  };

  const renderEngineTypeLabel = (type) => {
    const { label, icon } = engineTypeOptions.find(option => option.type === type);
    return (
      <Box display="flex" alignItems="center">
        <Box width="24px" display="flex" justifyContent="center" marginRight={1}>{icon}</Box>
        <Typography>{label}</Typography>
      </Box>
    );
  };

  return (
    <Form>
      <Checkbox
        id="all-engine-types"
        inputName="all"
        label={<Typography>All</Typography>}
        checked={selectedBrandManagementFilters.length === 4}
        onChange={onChange}
      />
      <Divider sx={{ mt: 1, mb: 1 }} />
      <EngineOptions>
        {engineTypeOptions.map(({ type }) => {
          const isChecked =
            selectedBrandManagementFilters.includes(type);
          return (
            <Checkbox
              key={type}
              id={type}
              inputName={type}
              label={renderEngineTypeLabel(type)}
              checked={isChecked}
              onChange={onChange}
            />
          );
        })}
      </EngineOptions>
    </Form>
  );
};

export default EngineFilterForm;


EngineFilterForm.propTypes = {
  selectedBrandManagementFilters: arrayOf(string).isRequired,
  updateCustomizations: func.isRequired,
};
